const urlConfig = {
  // 测试环境
  // url: 'https://api.gsisc.cn/',
  // devUrl: 'https://api.gsisc.cn/',
  // imgUrl: 'https://devfile.gsisc.cn/',
  // sign: 'https://devadmin.gsisc.cn/signa/',
  // file: {
  //   up: 'https://api.gsisc.cn/file/upload/',
  //   show: 'https://file.shyunhua.com/'
  // }

  // 线上环境
  url: "https://lanzhouapi.gsisc.cn/", // 线上环境
  devUrl: "https://lanzhouapi.gsisc.cn/",
  imgUrl: "https://file.shyunhua.com/", // 线上环境
  sign: "https://admin.gsisc.cn/signa/",
  file: {
    up: "https://lanzhouapi.gsisc.cn/file/upload/",
    show: "https://file.shyunhua.com/",
  },
};
if (process.env.NODE_ENV === "dev") {
  urlConfig.url = "http://127.0.0.1:40168/";
  urlConfig.devUrl = "http://127.0.0.1:40168/";
  urlConfig.sign = "http://127.0.0.1:40168/";
  // urlConfig.devUrl = 'http://192.168.10.9:40168/';
  // urlConfig.sign = "http://192.168.10.39:40168/";
  // urlConfig.devUrl = 'https://api.gsisc.cn/';
  // urlConfig.sign = 'https://api.gsisc.cn/'
}
(function() {
  window.urlConfig = urlConfig;
})();
export default urlConfig;
